import { supabase } from "@/lib/supabase";

export const normalizeSeasonDatePresets = (rawPresets) => {
  if (!Array.isArray(rawPresets)) return [];

  return rawPresets
    .map((preset, index) => {
      const name = String(preset?.name || "").trim();
      const from = String(preset?.from || "").trim();
      const to = String(preset?.to || "").trim();
      const active = preset?.active !== false;
      const id = String(preset?.id || `preset_${index + 1}`);

      if (!name || !from || !to) return null;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to)) return null;
      if (from > to) return null;

      return { id, name, from, to, active };
    })
    .filter(Boolean);
};

export const fetchSeasonDatePresets = async () => {
  try {
    const { data, error } = await supabase
      .from("app_settings")
      .select("season_date_ranges")
      .not("title", "is", null)
      .limit(1);

    if (error) {
      console.warn("No se pudieron cargar season_date_ranges:", error.message);
      return [];
    }

    return normalizeSeasonDatePresets(data?.[0]?.season_date_ranges || []);
  } catch (error) {
    console.warn("Error leyendo season_date_ranges:", error);
    return [];
  }
};

export const fetchPickingSeasonSettings = async () => {
  try {
    const { data, error } = await supabase
      .from("app_settings")
      .select("season_date_ranges, default_picking_season_preset_id")
      .not("title", "is", null)
      .limit(1);

    if (error) {
      console.warn("No se pudieron cargar los ajustes de temporada de picking:", error.message);
      return { presets: [], defaultPresetId: null };
    }

    const row = data?.[0] || {};
    return {
      presets: normalizeSeasonDatePresets(row.season_date_ranges || []),
      defaultPresetId: row.default_picking_season_preset_id || null,
    };
  } catch (error) {
    console.warn("Error leyendo ajustes de temporada de picking:", error);
    return { presets: [], defaultPresetId: null };
  }
};

export const toDateRangeFromPreset = (preset) => {
  if (!preset?.from || !preset?.to) return { from: null, to: null };
  return {
    from: new Date(`${preset.from}T00:00:00`),
    to: new Date(`${preset.to}T23:59:59`),
  };
};
